module.exports = __webpack_public_path__ + "static/media/avatar_gradios_positivo.a02445ea.png";